export const Bio = {
  name: "Volodymyr Fetisov",
  roles: ["Full Stack Developer", "Front-End Developer", "Programmer"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Fetivol",
  resume:
    "https://drive.google.com/file/d/15oshXODORac-iVtDuAl6ngpCHAMe6TI7/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/volodymyr-fetisov/",
  insta: "https://instagram.com/wlod_zio/",
  facebook: "https://www.facebook.com/vova.fetisov",
};

export const skills = [
  {
    id: 1,
    title: "Frontend",
    skills: [
      {
        id: 1,
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        id: 2,
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        id: 3,
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        id: 4,
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        id: 5,
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
    ],
  },
  {
    id: 2,
    title: "Backend",
    skills: [
      {
        id: 1,
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        id: 2,
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        id: 3,
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    id: 3,
    title: "Others",
    skills: [
      {
        id: 1,
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        id: 2,
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        id: 3,
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        id: 4,
        name: "Postman",
        image: "https://www.svgrepo.com/show/354202/postman-icon.svg",
      },
      {
        id: 5,
        name: "Figma",
        image:
          "https://seeklogo.com/images/F/figma-logo-E4E21D3AEA-seeklogo.com.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSwgYQvMpGebQdDGIHMYR01x6A60yUZRNYsg&s",
    role: "Senior Content Reviewer",
    company: "Teleperformance",
    date: "Sep 2022 - till now",
    desc: "Led the QA Subject Matter Expert (SME) team, overseeing task scheduling, training sessions, and refresher courses to enhance team performance and ensure alignment with organizational objectives. Facilitated regular team meetings, supported Team Leaders (TLs) and QA teams, and developed updated versions of “QA Answer Files” along with designing quizzes to maintain quality standards. Conducted shadowing and feedback sessions to mentor new hires and colleagues, completed appeals for absent team members, and prepared quizzes to promote team engagement. Additionally, reviewed videos for quality assurance purposes to uphold operational excellence.",
    skills: [
      "Team Leadership",
      "Training and Development",
      "Task Management",
      "Process Improvement",
      "Mentoring",
      "Problem-Solving",
      "Quality Assurance",
      "Communication",
      "Attention to details",
    ],
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSwgYQvMpGebQdDGIHMYR01x6A60yUZRNYsg&s",
    role: "Content Reviewer",
    company: "Teleperformance",
    date: "Sep 2021 - Aug 2022",
    desc: "I conducted team training sessions and refreshers to enhance knowledge and skills, reviewed videos to ensure quality standards, and provided ongoing support to Team Leaders (TLs) and QA teams. I developed updated versions of QA answer files and quizzes, facilitated shadowing and feedback sessions for new hires and colleagues, and managed appeals for team members who were out of office (OOO). Additionally, I scheduled and organized tasks to maintain workflow efficiency and created quizzes to assess and improve team performance.",
    skills: [
      "Content Creation",
      "Team Training and Development",
      "Mentoring",
      "Task Management",
      "Collaboration",
      "Quality Assurance",
      "Attention to details",
    ],
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/v2/C4E0BAQFauuKho485Mw/company-logo_200_200/company-logo_200_200/0/1631377946151/amrest_logo?e=2147483647&v=beta&t=MeUQLDDy5M_scK7GKdp1rE4hhRlZ51bOcCoxQLFcydk",
    role: "Product Shift Manager",
    company: "AmRest",
    date: "Oct 2019 - Sep 2021",
    desc: "Responsible for managing the Cost of Sales and PCA (losses), overseeing the restaurant team, and ensuring efficient product planning and procurement. Skilled in warehouse management, monitoring product quality, and planning sales, orders, and loss prevention strategies. Proficient in identifying and addressing inefficiencies, motivating team members, and fostering a productive work environment.",
    skills: [
      "Cost Management and Loss Prevention",
      "Team Leadership",
      "Team Motivation",
      "Product Planning",
      "Product Procurement",
      "Inventory Management",
      "Quality Assurance",
      "Strategic Planning and Analysis",
      "Problem-Solving",
      "Efficiency Improvement",
      "Sales and Order Forecasting",
    ],
  },
  {
    id: 3,
    img: "https://media.licdn.com/dms/image/v2/C4E0BAQFauuKho485Mw/company-logo_200_200/company-logo_200_200/0/1631377946151/amrest_logo?e=2147483647&v=beta&t=MeUQLDDy5M_scK7GKdp1rE4hhRlZ51bOcCoxQLFcydk",
    role: "Junior Shift Manager",
    company: "AmRest",
    date: "Jun 2019 - Sep 2019",
    desc: "As a Junior Shift Manager at KFC, I effectively managed a team, maintained customer contact, ensured product quality control, conducted staff training, and motivated team members to achieve operational excellence.",
    skills: [
      "Team Leadership",
      "Customer Service",
      "Quality Control",
      "Training and Development",
      "Problem-Solving",
      "Communication",
    ],
    doc: "https://drive.google.com/file/d/1FMKf3-YgbpqaERaWIrOtG8eeKBPbwAnD/view?usp=sharing",
    docimg: "https://live.staticflickr.com/65535/54219327832_4e0889a9c7_c.jpg",
  },
];

export const education = [
  {
    id: 0,
    img: "https://s.dou.ua/CACHE/images/img/static/companies/logo_orange_h-1000/962c575cd8c9b92611e28c997cec912f.png",
    school: "GoIT",
    date: "Feb 2023 - Jan 2024",
    desc: "Comprehensive training in HTML, CSS, JavaScript, React, Node.js, and TypeScript, focusing on both theoretical knowledge and practical applications through assignments and team projects.",
    degree: "Full-Stack Developer",
    doc: "https://drive.google.com/file/d/1vAwgwkF7GtFfUgBt_fboyvu5hPlMiCME/view?usp=sharing",
    docimg: "https://live.staticflickr.com/65535/54219327517_dbd258c713_c.jpg",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRoh4cKUUoBWG6Bgp9yS9vrQEU0vvyo6t2CaQ&s",
    school: "Web Academy",
    date: "2021",
    desc: "Completed comprehensive coursework covering the role of business analysis, SDLC fundamentals, effective communication strategies, requirements gathering techniques, documentation practices, modeling processes with BPMN and UML, and interface prototyping.",
    degree: "Business Analysis in IT",
    doc: "https://drive.google.com/file/d/1uj1S-Jy9rC5OqTR1KOo0PLKiK-Ekn-R5/view?usp=sharing",
    docimg: "https://live.staticflickr.com/65535/54220228826_c9939411bc_c.jpg",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXCidIoSwdQNroICe1hdtyonmJaJyF_FsnoQ&s",
    school: "Krakow University of Economics",
    date: "2018 - 2020",
    grade: "4.5",
    desc: "Master thesis - Analysis of basic processes in a fast food restaurant based on data from the product area.",
    degree: "Master of Engineering - MEng, Applied Informatics",
  },
  {
    id: 3,
    img: "https://upload.wikimedia.org/wikipedia/en/f/f0/Politechnika_swietokrzyska_logo.png",
    school: "Kielce University of Technology",
    date: "2014 - 2018",
    grade: "4.5",
    desc: "Bachelor thesis - Development of process models for a fruit and vegetable processing enterprise in the ARIS system.",
    degree: "Bachelor of Engineering, BE, Information Systems",
  },
];

export const projects = [
  {
    id: 6,
    title: "Educity",
    date: "2024",
    description:
      "The React Educity is a web application designed to provide users with an interactive platform for university students. Built using React, the application features a responsive layout that allows users to navigate through various sections. The project incorporates state management for seamless data handling and utilizes modern libraries and tools to enhance user experience.",
    image: "https://live.staticflickr.com/65535/54220438026_b8c51f51c3_h.jpg",
    tags: ["React Js", "JavaScript", "HTML", "CSS"],
    category: "react",
    github: "https://github.com/Fetivol/react-educity",
    webapp: "https://fetivol.github.io/react-educity/",
  },
  {
    id: 0,
    title: "Book Shelf",
    date: "2023",
    description:
      "Developed a JavaScript-based web application that enables users to view and add books to a shopping cart. The project features a responsive layout with a header that includes a logo, theme switcher, and burger menu for navigation. The home page showcases book categories, highlights charitable foundations, and lists available books. Users can access detailed information about each book through a modal window, which includes links to purchase resources. Additionally, the application provides a shopping list page for storing selected books in local storage, incorporates a loader for asynchronous requests, and features a scroll-up button for enhanced user convenience. This project demonstrates essential web development skills and offers basic functionality for an online book shopping platform.",
    image: "https://live.staticflickr.com/65535/54220278731_b5ae6901aa_b.jpg",
    tags: ["JavaScript", "CSS", "HTML", "REST APIs"],
    category: "html",
    github: "https://github.com/Fetivol/team-project-group-3-JS",
    webapp: "https://anetta999.github.io/team-project-group-3-JS/",
    member: [
      {
        name: "Serhii Kozhanov",
        img: "https://cdn-icons-png.flaticon.com/512/265/265674.png",
        linkedin: "https://www.linkedin.com/in/serhii-kozhanov/",
        github: "https://github.com/LIGHT131313",
      },
      {
        name: "Stanislav Boychuk",
        img: "https://cdn-icons-png.flaticon.com/512/265/265674.png",
        linkedin: "https://www.linkedin.com/in/stanislav-boychuk/",
        github: "https://github.com/Fasten-belts",
      },
    ],
  },
  {
    id: 2,
    title: "Water Tracker",
    date: "2023",
    description:
      "WaterTracker Application: Developed a comprehensive application that enables users to monitor their daily water consumption effectively. The app features user registration and login via password or Google Auth, along with password recovery through email confirmation. Users can edit their profiles, including avatar, name, email, and password, and have the option to delete their accounts along with their water consumption data. The application allows users to customize their daily water intake goals, add, update, and delete records of consumed water, and provides calculations for total water intake for the current day or selected month. This project emphasizes user-friendly design and functionality, making it easier for individuals to stay hydrated and manage their water consumption efficiently.",
    image: "https://live.staticflickr.com/65535/54219424482_c310b7829f_k.jpg",
    tags: [
      "Node.js",
      "Express.js",
      "MongoDb",
      "JWT",
      "CORS",
      "Swagger-ui-express",
      "Axios",
    ],
    category: "node",
    github: "https://github.com/LIGHT131313/WaterTracker_backend",
    webapp: "https://watertracker-backend.onrender.com/api-docs",
    member: [
      {
        name: "Serhii Kozhanov",
        img: "https://cdn-icons-png.flaticon.com/512/265/265674.png",
        linkedin: "https://www.linkedin.com/in/serhii-kozhanov/",
        github: "https://github.com/LIGHT131313",
      },
      {
        name: "Stanislav Boychuk",
        img: "https://cdn-icons-png.flaticon.com/512/265/265674.png",
        linkedin: "https://www.linkedin.com/in/stanislav-boychuk/",
        github: "https://github.com/Fasten-belts",
      },
    ],
  },
  {
    id: 1,
    title: "WatchSpot",
    date: "2023",
    description:
      "Responsive Website Project: Developed a fully responsive website optimized for various devices, ensuring compliance with HTML5 semantics and layout validity through standard validation tools. The project utilized font-face for typography, optimized image loading for both vector and raster graphics, and supported retina screens. Key features included the use of icon sprites and the addition of a favicon. The site comprised multiple sections such as Header, About Us, Catalog, Footer, Buy Now (popup), and a Burger menu for mobile devices, each designed with specific layout requirements for mobile (375px), tablet (768px), and desktop (1280px) views. Additionally, I served as the Scrum Master, organizing daily meetings, facilitating open team communication, monitoring project progress and deadlines, resolving issues, liaising with the mentor, and addressing bugs to ensure successful project delivery.",
    image: "https://live.staticflickr.com/65535/54219384147_ea6600ac7f_b.jpg",
    tags: ["HTML", "CSS", "Responsive Web Design"],
    category: "html",
    github: "https://github.com/Fetivol/watchspot",
    webapp: "https://light131313.github.io/watchspot/",
    member: [
      {
        name: "Serhii Kozhanov",
        img: "https://cdn-icons-png.flaticon.com/512/265/265674.png",
        linkedin: "https://www.linkedin.com/in/serhii-kozhanov/",
        github: "https://github.com/LIGHT131313",
      },
    ],
  },

  {
    id: 3,
    title: "WebStudio",
    date: "2023",
    description:
      "The project focuses on both the Markup and Styling aspects of web development. In Markup, it ensures proper HTML structuring using semantic tags, and key elements such as subscription and request forms are appropriately marked up. The Styling aspect underscores the consistent application of design principles, including transitions for hover and focus effects (overlays and 2D animations), the use of media queries for responsive design, and the integration of a mobile menu script. Additionally, the project pays attention to details such as icon utilization through SVG graphics, active states for interactive elements, and the correct implementation of modal windows with their associated scripts.",
    image: "https://live.staticflickr.com/65535/54220586654_a3f3ef8d8d_h.jpg",
    tags: ["HTML", "CSS", "Responsive Web Design"],
    category: "html",
    github: "https://github.com/Fetivol/WebStudio-HTML-CSS",
    webapp: "https://fetivol.github.io/WebStudio-HTML-CSS/",
  },
  {
    id: 4,
    title: "Search Image",
    date: "2023",
    description:
      "The project is a JavaScript application that allows users to search for and display images from the Pixabay API. It features a user-friendly interface with a search bar for entering keywords, displaying results in a responsive layout. The application supports infinite scrolling, automatically loading more images as users scroll down the page, enhancing the browsing experience. Users can click on individual images to view them in a larger format. This project showcases skills in API integration, asynchronous programming, and responsive web design, making it an excellent demonstration of front-end development capabilities.",
    image: "https://live.staticflickr.com/65535/54219467192_f1af3dfab7_h.jpg",
    tags: ["JavaScript", "HTML", "CSS", "REST API", "Responsive Web Design"],
    category: "html",
    github: "https://github.com/Fetivol/goit-js-hw-11",
    webapp: "https://fetivol.github.io/goit-js-hw-11/",
  },
  {
    id: 5,
    title: "Expense Tracker",
    date: "2024",
    description:
      "The Expense Tracker is a web application designed to help users manage and track their personal finances effectively. It allows users to add and delete expense records, view their financial data through a user-friendly interface",
    image: "https://live.staticflickr.com/65535/54220803215_81c5441477_b.jpg",
    tags: ["React", "JavaScript", "HTML", "CSS"],
    category: "react",
    github: "https://github.com/Fetivol/expence-tracker",
    webapp: "https://fetivol.github.io/expence-tracker/",
  },
];
